/** Results per section. The backend caps it at 20. */
export const MAGIC_SEARCH_LIMIT = 10;
